module.exports = __webpack_public_path__ + "static/media/TilePolicy.fd88a845.png";